import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Divider } from '@mui/material';

interface MediaTypeTabProps {
  to: string;
  label: string;
  isLastTab?: boolean;
}

/**
 * MediaTypeTab component - Renders a single tab in the media center navigation
 * Handles the active state styling and routing for the media type tabs
 */
export const MediaTypeTab: React.FC<MediaTypeTabProps> = ({
  to,
  label,
  isLastTab = false,
}) => {
  const location = useLocation();
  const isActive = location.pathname.endsWith(to);

  return (
    <>
      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
        <Box
          sx={{
            textAlign: 'center',
            width: { xs: '105px', sm: '120px' },
            py: 1,
            px: { xs: 0, sm: 1 },
            borderRadius: 2,
            backgroundColor: isActive ? 'states.default' : 'transparent',
            boxShadow: isActive ? 1 : 0,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: isActive ? 'states.default' : 'grey.50',
            },
            transition: 'background-color 0.2s ease',
          }}
        >
          {label}
        </Box>
      </Link>
      {!isLastTab && (
        <Divider
          orientation="vertical"
          variant="middle"
          sx={{
            borderWidth: 1,
            height: '24px',
            borderColor: isActive ? 'transparent' : 'grey.50',
          }}
        />
      )}
    </>
  );
};
